import { Field, Label, Widget } from '@kanda-libs/ks-component-ts';
import { Button, Loader, Text } from '@kanda-libs/ks-design-library';

import { Landmark } from 'lucide-react';

import { ACCOUNT_NUMBER_VALIDATION, ERROR_PROPS, PROPS } from './constants';
import useBankAccount from './useBankAccount';

import { YOUR_INFO_CLASS_NAMES } from '../constants';

export interface BankInformationFieldsProps {
  isSubmitting: boolean;
}

const BankInformationFields: React.FunctionComponent<BankInformationFieldsProps> =
  function ({ isSubmitting }) {
    const { sortCodeValidation, timeValidation, error, disabled } =
      useBankAccount();
    return (
      <>
        <div className="flex flex-col mb-3">
          <div className="flex flex-row gap-x-3 items-center mb-2">
            <Landmark size={20} />
            <Text
              className={YOUR_INFO_CLASS_NAMES.title}
              text="Bank Account Details"
            />
          </div>
          <Text
            className="text-14-22 text-neutral-700 mb-2"
            text="We need the account details for the bank account from which you want to make your monthly repayments"
          />
          <div className="grid grid-cols-2 gap-x-3 md:gap-x-4">
            <Widget.CreditBankAccountAccountName
              placeholder="Name on bank account (account holder's name)"
              className="col-span-2"
              label="Name On Bank Account"
            />
            <Widget.CreditBankAccountAccountNumber
              placeholder="e.g. 12345678"
              validation={ACCOUNT_NUMBER_VALIDATION}
            />
            <Widget.CreditBankAccountSortCode
              validation={sortCodeValidation}
              type="sortCode"
              placeholder="e.g 12-34-56"
            />
          </div>
          <Label label="How long have you help this account?" />
          <div className="grid grid-cols-2 gap-x-3 md:gap-x-4 w-full">
            <Field.NumberInput {...PROPS.accountYearsOwned} />
            <Field.NumberInput {...PROPS.accountMonthsOwned} />
          </div>
          {error && <Text text={error} className={ERROR_PROPS.className} />}
          <div className="hidden">
            <Widget.CreditBankAccountMonthsHeld validation={timeValidation} />
          </div>
          <Field.BooleanInput {...PROPS.confirmAccount} />
          <Field.BooleanInput {...PROPS.iva} />
          <Button.Text
            label="Submit your application"
            disabled={disabled || isSubmitting}
            id="apply-submit"
            submit
            icon="send"
            className="mt-2 mb-1"
          />
        </div>
        <Loader isLoading={isSubmitting} />
      </>
    );
  };

export default BankInformationFields;
